var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "protocol_detail_section"
  }, [_c('h3', {
    ref: "title",
    staticClass: "tit",
    attrs: {
      "data-depth": "0"
    }
  }, [_c('span', [_vm._v("용어설명")]), _vm.readonly === false ? _c('span', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isActive,
      expression: "!isActive"
    }],
    staticClass: "editContent",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.editorActive.apply(null, arguments);
      }
    }
  }, [_vm._v("편집")]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive,
      expression: "isActive"
    }],
    staticClass: "editContent",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.closeEditor.apply(null, arguments);
      }
    }
  }, [_vm._v("저장하기")])]) : _vm._e()]), _c('div', {
    staticClass: "editorArea"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isActive,
      expression: "!isActive"
    }],
    ref: "namo",
    attrs: {
      "id": "namoKeywordEditor"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contentText)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.editorActive.apply(null, arguments);
      }
    }
  }), _vm.readonly === false ? _c(_vm.NamoEditor, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive,
      expression: "isActive"
    }],
    tag: "div",
    staticClass: "namoArea",
    attrs: {
      "content": _vm.contentText
    },
    on: {
      "ready": function (editor) {
        return _vm.readyNamoEditor(editor);
      }
    }
  }) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }